
export const CONSTANTES = {
  URI_LOGIN: '/login'
}

export const CONSTANTES_SESION = {
  TOKEN: 'accessToken',
  USUARIO: 'usuario',
  USERNAME: 'username',
  INFO: 'info',
  NOMBRE: 'nombre'
}
